import React, { Component } from "react"
import { genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"
import {
    // PacClassicPacTransactionTypeFilterGroup
    PacClassicPacTransactionTypeFilter,
    // PacClassicPacTransactionAmountFilterGroup
    createPacClassicPacTransactionAmountFilter,
    // PacClassicPacTransactionDetailsFilterGroup
    PacClassicPacTransactionPACCIdFilter,
    PacClassicPacTransactionIsVoidFilter,
    PacClassicPacTransactionIsVoidDatePickerStartFilter,
    PacClassicPacTransactionIsVoidDatePickerEndFilter,
    PacClassicPacTransactionIsMemoEntryFilter,
    PacClassicPacTransactionIsReconciledFilter,
    // TransactionSupporterFilterGroup
    PacClassicPacTransactionSupporterFilter,
    // PacClassicPacTransactionPacOrganizationFilterGroup
    PacClassicPacTransactionPacOrganizationFilter,
    // TransactionOfficialFilterGroup
    // PacClassicPacTransactionOfficialFilter,
    // TransactionPacElectionFilterGroup
    PacClassicPacTransactionElectionFilter,
    // PacClassicPacTransactionOrganizationFilterGroup
    PacClassicPacTransactionOrganizationFilter,
} from "shared/search/containers/Filter/PacClassicPacTransactionFilters"

// helpers
import { checkHasPermission } from "shared/imports/permissionFunctions"

export const PacClassicPacTransactionTypeFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionTypeFilterGroup.defaultProps = {
    displayLabel: "Transaction Type",
    filters: [PacClassicPacTransactionTypeFilter],
    helpText: "Filter transactions by type.",
    uniqueFilterGroupId: "pacClassicPacTransactionTypeFilterGroup",
}

export const PacClassicPacTransactionDetailsFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionDetailsFilterGroup.defaultProps = {
    filters: [
        // TODO: this doesn't exist — is there an analogue to qpac's itemization_certificate__serial_number in Pac Classic
        // PacClassicPacTransactionSerialNumberFilter,
        PacClassicPacTransactionPACCIdFilter,
        PacClassicPacTransactionIsVoidFilter,
        PacClassicPacTransactionIsVoidDatePickerStartFilter,
        PacClassicPacTransactionIsVoidDatePickerEndFilter,
        PacClassicPacTransactionIsMemoEntryFilter,
        PacClassicPacTransactionIsReconciledFilter,
    ],
    uniqueFilterGroupId: "pacClassicPacTransactionDetailsFilterGroup",
    displayLabel: "Transaction ID / Void / Reconciled",
    helpText: "Filter Results by transaction id or whether it is void or reconciled",
}

export const PacClassicPacTransactionSupporterFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionSupporterFilterGroup.defaultProps = {
    filters: [PacClassicPacTransactionSupporterFilter],
    uniqueFilterGroupId: "pacClassicPacTransactionSupporterFilterGroup",
    displayLabel: "Contacts",
    helpText: "Filter Results by Contacts.",
}

// TODO: after adding PacClassicLegislator model, add this back and
// update app/pac_classic/models/transaction.py PacClassicPacTransactionQuerySet transaction_person
// export const PacClassicPacTransactionOfficialFilterGroup = (props) => genericFilterGroup(props)
// PacClassicPacTransactionOfficialFilterGroup.defaultProps = {
//     filters: [PacClassicPacTransactionOfficialFilter],
//     uniqueFilterGroupId: "pacClassicPacTransactionOfficialFilterGroup",
//     displayLabel: "Officials",
//     helpText: "Filter Results by Officials.",
// }

export const PacClassicPacTransactionPacOrganizationFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionPacOrganizationFilterGroup.defaultProps = {
    filters: [PacClassicPacTransactionPacOrganizationFilter],
    uniqueFilterGroupId: "pacClassicPacTransactionPacOrganizationFilterGroup",
    displayLabel: "PAC Organizations",
    helpText: "Filter Results by PAC Organization (PAC).",
}

export const PacClassicPacTransactionElectionFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionElectionFilterGroup.defaultProps = {
    filters: [PacClassicPacTransactionElectionFilter],
    uniqueFilterGroupId: "PacClassicPacTransactionElectionFilterGroup",
    displayLabel: "Elections",
    helpText: "Filter Results by Election (PAC).",
}

export const PacClassicPacTransactionOrganizationFilterGroup = (props) => genericFilterGroup(props)
PacClassicPacTransactionOrganizationFilterGroup.defaultProps = {
    filters: [PacClassicPacTransactionOrganizationFilter],
    uniqueFilterGroupId: "pacClassicPacTransactionOrganizationFilterGroup",
    displayLabel: "Organizations",
    helpText: "Filter Results by Organization (PAC).",
}

export const createPacClassicPacTransactionsFilterGroup = ({ displayLabel, quorumDataType, uniqueFilterGroupId }) => {
    class PacClassicPacTransactionAmountFilterGroup extends Component {
        render() {
            return genericFilterGroup({
                uniqueFilterGroupId,
                displayLabel,
                helpText: "Filter by transactions.",
                ...this.props,
            })
        }
    }

    PacClassicPacTransactionAmountFilterGroup.defaultProps = {
        quorumDataType,
        displayLabel: "Transaction Details",
        uniqueFilterGroupId,
        isConnectedFilterGroup: false,
        filters: [
            ...(checkHasPermission([DjangIO.app.models.PermissionType.pac_hybrid])
                ? [createPacClassicPacTransactionAmountFilter({ quorumDataType })]
                : []),
        ],
    }

    return PacClassicPacTransactionAmountFilterGroup
}

export const PacClassicPacTransactionAmountFilterGroup = createPacClassicPacTransactionsFilterGroup({
    quorumDataType: DjangIO.app.models.QuorumDataType.pacc_pac_transaction,
    uniqueFilterGroupId: "pacClassicPacTransactionFilterGroup",
})
